import { render, staticRenderFns } from "./MyGDQPage.vue?vue&type=template&id=dfb1a998&scoped=true"
import script from "./MyGDQPage.vue?vue&type=script&lang=js"
export * from "./MyGDQPage.vue?vue&type=script&lang=js"
import style0 from "./MyGDQPage.vue?vue&type=style&index=0&id=dfb1a998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb1a998",
  null
  
)

export default component.exports